import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.token) {
      setAuth(true);
    }
  }, []);

  const login = (userData) => {
    setAuth(true);
    navigate('/home');
  };

  const logout = () => {
    // localStorage.removeItem("user")
    // localStorage.removeItem("lang")
    // localStorage.removeItem("__paypal_storage__")
    // localStorage.removeItem("balance")
    // localStorage.removeItem("address_id")
    // localStorage.removeItem("address_id")
    localStorage.clear();

    setAuth(false);
    navigate('/home');
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
